// Types for cookie preferences
export type CookiePreference = 'accepted' | 'rejected' | undefined;

// Check if cookies are allowed
export const areCookiesAllowed = (): boolean => {
  return localStorage.getItem('cookiesAccepted') === 'true';
};

// Get current cookie preference
export const getCookiePreference = (): CookiePreference => {
  const preference = localStorage.getItem('cookiesAccepted');
  if (preference === 'true') return 'accepted';
  if (preference === 'false') return 'rejected';
  return undefined;
};

// Remove all existing cookies
export const removeAllCookies = (): void => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  }
};

// Disable tracking features
export const disableTracking = (): void => {
  // Disable Google Analytics
  if (window.ga) {
    window['ga-disable-' + window.ga.getAll()[0].get('trackingId')] = true;
  }

  // Disable other tracking features as needed
  // Add any other tracking services your app uses
};

// Initialize cookie preferences
export const initializeCookiePreferences = (): void => {
  const preference = getCookiePreference();

  if (preference === 'rejected') {
    removeAllCookies();
    disableTracking();

    // Create an observer to remove any new cookies that might be set
    const cookieObserver = setInterval(() => {
      if (document.cookie) {
        removeAllCookies();
      }
    }, 1000);

    // Store the interval ID in localStorage to clear it if preferences change
    localStorage.setItem('cookieObserverId', cookieObserver.toString());
  } else if (preference === undefined) {
    // If no preference is set, we'll show the banner
    // The CookieAccept component handles this case
  }
};

// Clean up cookie observer
export const cleanupCookieObserver = (): void => {
  const observerId = localStorage.getItem('cookieObserverId');
  if (observerId) {
    clearInterval(parseInt(observerId));
    localStorage.removeItem('cookieObserverId');
  }
};
